import React from 'react';
import emptyScreenImg from '../../../assets/images/empty-screen-avatar.png';
import { IoAdd } from 'react-icons/io5';
import { StyledDataBar } from './EmptyScreen.styles';
import EmptyScreen from '.';

const LeadsEmptyScreen = ({ onButtonClick }) => (
    <EmptyScreen
        illustration={emptyScreenImg}
        header={{ title: 'Emily Sanders', subtitle: 'Head of Sales' }}
        tag="New Lead"
        title="No Leads Yet"
        description="Add leads to Houdiny through CSV upload or Linkedin scraping."
        btnWidth="150px"
        buttonLabel="Add Leads"

        buttonIcon={IoAdd}
        onButtonClick={onButtonClick}
    >
        <div className="bar-holder">
            <div>
                <StyledDataBar width="50px" background="#7F8594" />
                <StyledDataBar width="80px" background="#7F8594" />
                <StyledDataBar width="60px" background="#7F8594" />
                <StyledDataBar width="75px" background="#7F8594" />
                <StyledDataBar width="90px" background="#7F8594" />
            </div>
            <div>
                <StyledDataBar width="50px" alignRight />
                <StyledDataBar width="80px" alignRight />
                <StyledDataBar width="60px" alignRight />
                <StyledDataBar width="75px" alignRight />
                <StyledDataBar width="90px" alignRight />
            </div>
        </div>
    </EmptyScreen>
);

export default LeadsEmptyScreen;